export const SubscriptionReactivationSelectors = {
    section: ".subscription-reactivation",
    returnSubscriptionButtonSelector: ".subscription-reactivation__bottom-button",
    returnSubscriptionModalSelector: ".subscription-reactivation__return-subscription",
    errorModalSelector: ".subscription-reactivation__error",
    thankYouModalSelector: ".subscription-reactivation__thank-you",
    submitButtonSelector: ".subscription-reactivation__submit-button",
    closeButtonSelector: ".subscription-reactivation__close-this-modal",
    spinner: "subscription-reactivation__modal-content__button-spinner",
    modalBackgroundSelector: ".subscription-reactivation__modal-background",
    hiddenClassName: "hidden",
    content: ".dm-subscription-reactivation-content",
    contentThankYou: ".dm-subscription-reactivation-thank-you",
    bottom: ".dm-subscription-reactivation-bottom",
    bottomThankYou: ".dm-subscription-reactivation-bottom-thank-you",
};
export const SubscriptionReactivationConstants = {
    SUBSCRIPTION_REACTIVATION_KEY: "DM_SUBSCRIPTION_REACTIVATION_KEY",
};
